export default __webpack_public_path__ + "static/media/I18.801f7a1f.jpg";